"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignIn = void 0;
const ClientContext_1 = require("../contexts/ClientContext");
const IsomorphicClerkContext_1 = require("../contexts/IsomorphicClerkContext");
const useSignIn = () => {
    const isomorphicClerk = (0, IsomorphicClerkContext_1.useIsomorphicClerkContext)();
    const client = (0, ClientContext_1.useClientContext)();
    if (!client) {
        return { isLoaded: false, signIn: undefined, setSession: undefined };
    }
    return { isLoaded: true, signIn: client.signIn, setSession: isomorphicClerk.setSession };
};
exports.useSignIn = useSignIn;
//# sourceMappingURL=useSignIn.js.map